module.exports = __webpack_public_path__ + "img/update3.5_image05.df70ac25.png";